export const BE_URL = 'https://auth.raspberryshake.org/'
export const FE_URL = 'https://sound.raspberryshake.org/'
